module.exports = __webpack_public_path__ + "static/9-44a92f327cf3330e2309ceb6cfff4a1c.jpg";